import {isString, compact, uniq, flatten, filter, includes} from "lodash"

import doValidation from "@irati/utils/validation/shared/doValidation"

export const DONT_INCLUDE = "dont_include"
export const FIRSTNAME = "firstName"
export const LASTNAME = "lastName"
export const EMAIL = "email"
export const ROLES = "roles"
export const TEAMS = "teams"
export const EXTERNAL_ID = "externalUserId"

const i18nKeyFirstName = "admin.components.addPeopleCSV.fieldsMapping.firstName.label"
const i18nKeyLatName = "admin.components.addPeopleCSV.fieldsMapping.lastName.label"
const i18nKeyEmail = "admin.components.addPeopleCSV.fieldsMapping.email.label"
const i18nKeyRole = "admin.components.addPeopleCSV.fieldsMapping.role.label"
const i18nKeyTeam = "admin.components.addPeopleCSV.fieldsMapping.team.label"
const i18nKeyExternalId = "admin.components.addPeopleCSV.fieldsMapping.externalId.label"

const emailIndexInRow = (row) => {
  return Object.values(row).findIndex((header) => header.includes("@"))
}

const trimValue = (value) => {
  if (!isString(value)) {
    return value
  }
  return value.trim().length > 0 ? value.trim() : null
}

export const getUserCSVHeaders = (row, formatMessage) => {
  const emailIndex = emailIndexInRow(row)
  if (emailIndex >= 0) {
    return Object.values(row).map((col, i) => {
      if (emailIndex === i) {
        return "email"
      }
      return ""
    })
  }

  const i18nFirstName = formatMessage({id: i18nKeyFirstName})
    .replace(" ", "")
    .toLowerCase()
  const i18nLastName = formatMessage({id: i18nKeyLatName})
    .replace(" ", "")
    .toLowerCase()
  const i18nEmail = formatMessage({id: i18nKeyEmail})
    .replace(" ", "")
    .toLowerCase()
  const i18nRole = formatMessage({id: i18nKeyRole})
    .replace(" ", "")
    .toLowerCase()
  const i18nTeam = formatMessage({id: i18nKeyTeam})
    .replace(" ", "")
    .toLowerCase()
  const i18nExternalId = formatMessage({id: i18nKeyExternalId})
    .replace(" ", "")
    .toLowerCase()

  return [
    ...Object.values(row).map((column) => {
      let label
      switch (column.replace(" ", "").toLowerCase()) {
        case FIRSTNAME:
        case i18nFirstName:
        case "firstname":
        case "fname":
          label = FIRSTNAME
          break
        case LASTNAME:
        case i18nLastName:
        case "lastname":
        case "lname":
          label = LASTNAME
          break
        case EMAIL:
        case i18nEmail:
        case "emailaddress":
          label = EMAIL
          break
        case ROLES:
        case i18nRole:
          label = ROLES
          break
        case TEAMS:
        case i18nTeam:
        case "team":
          label = TEAMS
          break
        case EXTERNAL_ID:
        case i18nExternalId:
        case "externalid":
          label = EXTERNAL_ID
          break
        default:
          label = ""
          break
      }
      return label
    })
  ]
}

export const getUserCSVRows = (rows) => {
  const emailIndex = emailIndexInRow(rows[0])

  if (emailIndex >= 0) {
    // first row has an email so no headers, return all
    return rows
  }

  return rows.slice(1)
}

export const csvRowToUser = (headers, row) => {
  let user = {}
  const errors = []
  headers.forEach((header, idx) => {
    const label = header
    let value = row[Object.keys(row)[idx]]

    if (header && header !== DONT_INCLUDE) {
      if ([FIRSTNAME, LASTNAME, EMAIL, TEAMS, EXTERNAL_ID].indexOf(header) > -1) {
        value = trimValue(value)
      }
      if (header !== ROLES && header !== TEAMS && header !== EXTERNAL_ID) {
        const check = doValidation({label, value})
        if (!check.isValid) {
          errors.push(`${label} is not valid`)
        }
      }
      user = {...user, [label]: value}
    }
  })
  return {user, errors}
}

export const getUniqueEmails = (emails) => {
  return compact(uniq(flatten(emails)))
}

export const getDuplicateEmails = (emails) => {
  return compact(
    filter(flatten(emails), (value, index, iteratee) => {
      return includes(iteratee, value, index + 1)
    })
  )
}
